var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-badge',_vm._b({staticClass:"sme-badge",class:[_vm.large && 'sme-badge--large'],attrs:{"variant":_vm.variant,"pill":""}},'b-badge',_setup.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }